import { render, staticRenderFns } from "./ComUserPer.vue?vue&type=template&id=21ad984f&scoped=true&"
import script from "./ComUserPer.vue?vue&type=script&lang=js&"
export * from "./ComUserPer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad984f",
  null
  
)

export default component.exports